var _defs, _path, _use, _use2, _use3, _use4, _use5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCn = function SvgCn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "#ffde00",
    d: "M-.588.81L0-1 .588.81-.952-.31H.952z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h640v480H0z",
    fill: "#de2910"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "matrix(71.9991 0 0 72 119.999 120)",
    width: 30,
    height: 20
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "matrix(-12.33562 -20.5871 20.58684 -12.33577 240.291 47.996)",
    width: 30,
    height: 20
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "matrix(-3.38573 -23.75998 23.75968 -3.38578 287.95 95.796)",
    width: 30,
    height: 20
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "matrix(6.5991 -23.0749 23.0746 6.59919 287.959 168.012)",
    width: 30,
    height: 20
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "matrix(14.9991 -18.73557 18.73533 14.99929 239.933 216.054)",
    width: 30,
    height: 20
  })));
};
export default __webpack_public_path__ + "assets/5d8314255775eb78b4277622e83874d7.svg";
export { SvgCn as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/cn.svg